"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLocationResponse = exports.mapLocationPendingInviteResponse = exports.mapLocationACLResponse = exports.mapLocationACLProfileResponse = void 0;
const urls_1 = __importDefault(require("./urls"));
const mapLocationACLProfileResponse = (p) => ({
    id: p.id,
    email: p.email,
    name: p.name,
    thumbnailUrl: p.thumbnail_url,
    domainId: p.domain_id,
    domainRole: p.domain_role,
});
exports.mapLocationACLProfileResponse = mapLocationACLProfileResponse;
const mapLocationACLResponse = (acl) => ({
    id: acl.id,
    grantProfile: acl.grant_profile && (0, exports.mapLocationACLProfileResponse)(acl.grant_profile),
    grantDomainId: acl.grant_domain_id,
    grantScope: acl.grant_scope,
    readGrant: acl.read_grant,
    updateGrant: acl.update_grant,
    deleteGrant: acl.delete_grant,
    customAccessGrants: acl.custom_access_grants,
    shareGrant: acl.share_grant,
    fullGrant: acl.full_grant,
});
exports.mapLocationACLResponse = mapLocationACLResponse;
const mapLocationPendingInviteResponse = (pi) => ({
    inviteId: pi.invite_id,
    email: pi.email,
    name: pi.name,
    domainRole: pi.domain_role,
    lastSentAt: pi.last_sent_at,
});
exports.mapLocationPendingInviteResponse = mapLocationPendingInviteResponse;
const mapLocationResponse = (l) => ({
    id: l.id,
    name: l.name,
    description: l.description,
    createdAt: l.created_at,
    updatedAt: l.updated_at,
    acl: l.acl.map((acl) => (0, exports.mapLocationACLResponse)(acl)),
    aclPendingInvites: l.acl_pending_invites.map((invite) => (0, exports.mapLocationPendingInviteResponse)(invite)),
});
exports.mapLocationResponse = mapLocationResponse;
class LocationClient {
    getLocations(query) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.locations(query),
            });
            return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.map(exports.mapLocationResponse);
        });
    }
    createLocation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.locations(),
                body: {
                    name: params.name,
                    description: params.description,
                },
            });
            return (0, exports.mapLocationResponse)(data);
        });
    }
    editLocation(locationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.location(locationId),
                body: {
                    name: params.name,
                    description: params.description,
                },
            });
            return (0, exports.mapLocationResponse)(data);
        });
    }
    deleteLocation(locationId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.location(locationId),
            });
        });
    }
    getPendingLocations() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.pendingLocations(),
            });
            return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.map(exports.mapLocationResponse);
        });
    }
    inviteUserToLocation(locationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const bodyStruct = {};
            if (params.profileId) {
                params.profileId && (bodyStruct.profile_id = params.profileId);
            }
            else if (params.inviteId) {
                params.inviteId && (bodyStruct.invite_id = params.inviteId);
            }
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.inviteUserToLocation(locationId),
                body: bodyStruct,
            });
            return (0, exports.mapLocationResponse)(data);
        });
    }
    removeUserFromLocation(locationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const bodyStruct = {};
            if (params.profileId) {
                params.profileId && (bodyStruct.profile_id = params.profileId);
            }
            else if (params.inviteId) {
                params.inviteId && (bodyStruct.invite_id = params.inviteId);
            }
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.removeUserFromLocation(locationId),
                body: bodyStruct,
            });
            return (0, exports.mapLocationResponse)(data);
        });
    }
    moveDevicesToAnotherLocation(locationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.moveDevices(locationId),
                body: {
                    device_ids: params.deviceIds,
                },
            });
        });
    }
}
exports.default = LocationClient;
